import React from 'react';
import { AutoComplete, Button, Col, Form, Input, Modal, Row } from 'antd';
import { observer } from 'mobx-react';
import { useStores } from '@gtintel/platform-stores';
const TagCreationModal = props => {
  const {
    modal1Visible,
    name,
    isSubmitting,
    setModal1Visible,
    submitCreate,
    nameChange,
    grChange
  } = props;
  const {
    tagGroupStore
  } = useStores();
  const {
    tagTypeOptions
  } = tagGroupStore;
  return <Modal title="Create Tag" style={{
    top: 20
  }} visible={modal1Visible} onCancel={() => setModal1Visible(false)} className="createTag formTag" footer={null}>
      <Form name="basic" onFinish={submitCreate}>
        <Form.Item className="form" label="Tag" name="tag" rules={[{
        required: true,
        message: 'Please input your tag!'
      }]}>
          <Input data-testid="tag-name-input" size="large" value={name} name="name" placeholder="Name" onChange={nameChange} className="width-360" />
        </Form.Item>
        <Form.Item className="form select" label="Type" name="group" rules={[{
        required: true,
        message: 'Please select your group!'
      }]}>
          <AutoComplete dropdownMatchSelectWidth={293} options={tagTypeOptions} onChange={grChange}>
            <Input.Search placeholder="Input here" />
          </AutoComplete>
        </Form.Item>
        <Row>
          <Col>
            <Form.Item>
              <Button data-testid="create-button" className="btn-save save" type="primary" htmlType="submit" loading={isSubmitting}>
                CREATE
              </Button>
            </Form.Item>
          </Col>
          <Col>
            <Form.Item>
              <Button data-testid="cancel-button" className="btn-cancel cancel" loading={isSubmitting} onClick={() => setModal1Visible(false)}>
                CANCEL
              </Button>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>;
};
export default observer(TagCreationModal);